<template>
	<LoginLayout
		heading="Access Required"
	>
		<template #form>
			<div class="text-center">
				<div class="login-icon-roundel mb-6">
					<v-icon size="32">
						mdi-shield-alert-outline
					</v-icon>
				</div>
			</div>
			<Message type="info">
				<div
					v-for="(paragraph, index) in reasonMessages"
					:key="index"
					:class="{ 'mt-2': index > 0 }"
				>
					{{ paragraph }}
				</div>
			</Message>
			<div class="mt-4 text-center text-subtitle-2">
				<div>
					Already had access granted?
				</div>
				<div>
					Log out and sign back in to refresh your permissions.
				</div>
			</div>
			<div class="text-center mt-4">
				<TextButton
					class="text-decoration-underline"
					@click="returnToLogin"
				>
					Log out of Identity Provider
				</TextButton>
			</div>
		</template>
	</LoginLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LoginLayout from '../../../../../shared/layouts/login-layout.vue'
import Message from '../../../../../shared/components/message.vue'
import TextButton from '../../../../../shared/components/text-button.vue'

const REASON_MESSAGES = {
	brands: [
		'Your account has a valid role but is not associated with any brands for this portal.',
		'An administrator must assign one or more brands to your account.',
		'Once brand access is added, log out of your Identity Provider and sign in again to refresh your access.'
	],
	permissions: [
		'Your account does not currently have a role that allows access to this portal.',
		'Please ask an administrator to assign the correct role.',
		'After the role has been added, log out of your Identity Provider and sign in again to apply the change.'
	],
	default: [
		'Your account is missing both a required user role and brand for this portal.',
		'An administrator must assign the appropriate role and brand(s) to your account.',
		'Once access has been granted, log out of your Identity Provider and sign in again to refresh your permissions.'
	]
}

export default {
	components: { LoginLayout, Message, TextButton },
	computed: {
		...mapGetters('auth', {
			reason: 'insufficientAccessReason'
		}),
		reasonMessages () {
			return REASON_MESSAGES[this.reason] || REASON_MESSAGES.default
		}
	},
	methods: {
		...mapActions('auth', ['logOut']),
		returnToLogin () {
			// Clear the insufficient access state
			this.$store.commit('auth/SET_INSUFFICIENT_ACCESS', false)
			this.$store.commit('auth/SET_INSUFFICIENT_ACCESS_REASON', null)
			// Use logOut to properly sign out of SSO provider, allowing re-authentication
			this.logOut()
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .v-card {
	max-width: 600px;
}
</style>
